"use strict"

import React from "react"
import {observer} from "mobx-react"

import RouterStore from "../../global/store/RouterStore"

@observer
export default class Referencie extends React.Component {
	constructor(props) {
		super(props)

		window.scrollTo(0, 0)
	}

	componentDidMount() {
		let scripts = [
			"../public/scripts/jquery.min.js",
			"../public/scripts/popper.min.js",
			"../public/scripts/bootstrap.js",
			"../public/scripts/moment.min.js",
			"../public/scripts/moment-business.js",
			"../public/scripts/aos.js",
			"../public/scripts/clipboard.js",
			"../public/scripts/jquery.fancybox.min.js",
			"../public/scripts/flickity.pkgd.min.js",
			"../public/scripts/ion.rangeSlider.min.js",
			"../public/scripts/isotope.pkgd.min.js",

			"../public/scripts/jarallax.min.js",
			"../public/scripts/jarallax-video.min.js",
			"../public/scripts/jarallax-element.min.js",
			"../public/scripts/jquery.countdown.min.js",
			"../public/scripts/plyr.polyfilled.min.js",
			"../public/scripts/prism.js",
			"../public/scripts/scrollMonitor.js",
			"../public/scripts/smooth-scroll.polyfills.js",
			"../public/scripts/twitterFetcher_min.js",
			"../public/scripts/typed.min.js",
			"../public/scripts/theme.js",
			"../public/scripts/controller.js",

			"../public/scripts/sweetalert.min.js",
			"../public/scripts/maine.js"
		]

		for (let i = 0; i < scripts.length; i++) {
			const script = document.createElement("script")
			script.src = scripts[i]
			script.async = false
			// script.onload = () => document.querySelector("body").classList.add("loaded")

			document.body.appendChild(script)
		}
		document.querySelector("body").classList.add("loaded")
	}

	componentWillUnmount() {
		let scripts = document.getElementsByTagName("script")
		for (let i = 0; i < scripts.length; i++) {
			scripts[i].parentNode.removeChild(scripts[i])
		}
	}

	render() {
		return (
			<React.Fragment>
				<section className="bg-primary-alt header-inner o-hidden">
					<div className="container">
						<div className="row my-3">
							<div className="col">
								<nav aria-label="breadcrumb">
									<ol className="breadcrumb">
										<li className="breadcrumb-item">
											<a className="pointer blueColor" onClick={() => RouterStore.push("./")}>
												am<b>bee</b>
											</a>
										</li>
										<li className="breadcrumb-item active" aria-current="page">
											Referencie
										</li>
									</ol>
								</nav>
							</div>
						</div>
						<div className="row pt-5 py-5 text-center justify-content-center align-items-center layer-2">
							<div className="col-xl-8 col-lg-10">
								<h1 className="display-4">Orientovaný na pacienta.</h1>
								<p className="lead mb-0">
									Áno. Systém je taký, aby ste čo najviac času trávili s pacientom. Počúvame používateľov a spolu s nimi
									kontinuálne dolaďujeme.
								</p>
							</div>
						</div>
					</div>
					<div className="decoration top right scale-2 d-none d-lg-block" data-jarallax-element="-200">
						<svg
							className="bg-secondary"
							width="298"
							height="197"
							viewBox="0 0 298 197"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M271.518 116.857C266.116 125.511 259.584 133.287 253.194 141.164C248.36 147.125 243.548 153.103 238.583 158.953C236.134 161.84 233.362 164.453 230.733 167.185C229.881 168.072 228.921 168.871 228.172 169.833C225.727 172.979 222.572 175.452 220.145 178.651C217.581 182.032 213.84 184.145 210.204 186.288C201.958 191.145 193.024 193.809 183.61 195.366C174.13 196.932 164.633 196.987 155.102 196.749C148.211 196.575 141.723 194.466 135.547 191.72C126.522 187.704 117.201 184.554 107.795 181.695C102.133 179.974 96.211 179.015 90.348 178.072C82.455 176.801 74.483 176.021 66.59 174.748C61.49 173.924 56.395 173.656 51.27 173.844C41.399 174.205 31.62 172.856 21.799 172.319C17.233 172.069 12.623 171.329 8.32199 169.428C3.47399 167.289 0.64998 163.86 0.50198 158.356C0.33398 152.055 1.14497 145.872 2.36097 139.725C4.05597 131.147 6.94698 122.92 9.63998 114.625C11.435 109.1 14.044 104.068 17.138 99.191C20.263 94.261 22.833 88.964 26.156 84.181C28.943 80.169 32.218 76.415 35.73 73.013C39.232 69.62 43.835 67.853 48.488 66.47C49.535 66.159 50.73 66.247 51.851 66.298C56.263 66.493 60.572 67.214 64.898 68.22C71.472 69.749 77.906 72.04 84.709 72.466C87.564 72.646 90.438 72.616 93.301 72.558C98.117 72.46 102.93 72.236 107.746 72.117C113 71.986 117.902 70.75 122.18 67.582C129.756 61.973 137.328 56.355 144.856 50.678C150.336 46.543 155.829 42.416 161.157 38.088C167.837 32.662 174.261 26.918 180.968 21.529C186.708 16.916 192.419 12.265 198.823 8.50796C202.481 6.35996 206.471 5.08997 210.255 3.29897C212.142 2.40397 214.415 2.16795 216.544 1.97295C222.355 1.43795 228.177 0.931955 234.007 0.701955C239.169 0.498955 244.191 1.50895 249.097 3.18795C256.88 5.85395 264.337 9.12595 271.404 13.417C275.808 16.089 280.133 18.696 283.58 22.601C285.338 24.591 287.455 26.2709 289.187 28.2829C296.781 37.0899 298.767 47.203 296.302 58.465C295.044 64.211 293.189 69.723 290.986 75.139C287.625 83.399 284.443 91.746 280.726 99.846C278.041 105.691 274.613 111.197 271.518 116.857ZM95.393 132.113C95.569 132.066 95.745 132.021 95.92 131.974C95.768 131.382 95.617 130.788 95.465 130.197C95.283 130.244 95.102 130.291 94.922 130.338C95.078 130.93 95.236 131.521 95.393 132.113ZM225.68 158.404C225.83 158.343 225.985 158.293 226.121 158.211C226.142 158.199 226.103 157.986 226.062 157.977C225.916 157.94 225.755 157.948 225.601 157.938C225.627 158.092 225.652 158.248 225.68 158.404Z"
								fill="black"
							/>
						</svg>
					</div>
				</section>
				<section className="pb-0 pt-4 bg-primary-alt mb-lg-n7">
					<div className="container">
						<div className="row">
							<div className="col layer-1">
								<a className="card card-article-wide flex-md-row no-gutters hover-shadow-3d">
									<div className="col-md-5 col-lg-6">
										<img
											src="public/images/ambee-testimonial-mudr-michaela-machacova-horizontal.jpg"
											alt="MUDr. Michaela Macháčová"
											className="card-img-top"
										/>
									</div>
									<div className="card-body d-flex flex-column justify-content-between col-auto p-4 p-lg-5">
										<div>
											<p className="lead mb-0">MUDr. Michaela Macháčová</p>
											<p className="mb-3 text-muted">
												všeobecný lekár pre dospelých
												<br />
												Topoľčany,
												<b>2&nbsp;496</b> pacientov
											</p>
											<div className="h3">
												Odoslanie pacienta k špecialistovi a následná možnosť zobraziť výsledok vyšetrenia v am
												<b>bee</b> je skvelá! Táto nová funkcionalita mi šetrí veľa času a minimalizuje chyby.
											</div>
										</div>
									</div>
								</a>
							</div>
						</div>
					</div>
					<div className="divider layer-0">
						<svg
							width="100%"
							height="96px"
							viewBox="0 0 100 100"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
							preserveAspectRatio="none"
						>
							<path d="M0,0 C16.6666667,66 33.3333333,99 50,99 C66.6666667,99 83.3333333,66 100,0 L100,100 L0,100 L0,0 Z"></path>
						</svg>
					</div>
				</section>

				<section className="pt-5">
					<div className="container">
						<div className="row">
							<div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
								<div className="card hover-shadow-3d">
									<a>
										<img
											src="public/images/ambee-testimonial-mudr-stefan-krnac-horizontal.jpg"
											alt="MUDr. Štefan Krnáč, všeobecný lekár"
											className="card-img-top"
										/>
									</a>
									<div className="card-body align-items-start">
										<p className="lead mb-0">MUDr. Štefan Krnáč</p>
										<p className="mb-3 text-muted">
											všeobecný lekár pre dospelých
											<br />
											Detva
											<br />
											<b>6&nbsp;785</b>
											pacientov
										</p>
										<div className="h3">
											am<b>bee</b> sme si so sestričkou rýchlo obľúbili. Systém je jednoduchý, intuitívny a
											samonavádzací.
										</div>
									</div>
								</div>
							</div>
							{/* <!-- Stefan Krnac --> */}

							<div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
								<div className="card hover-shadow-3d">
									<a>
										<img
											src="public/images/ambee-testimonial-mudr-sona-ostrovska-horizontal.jpg"
											alt="MUDr. Soňa Ostrovská, všeobecný lekár"
											className="card-img-top"
										/>
									</a>
									<div className="card-body align-items-start">
										<p className="lead mb-0">MUDr. Soňa Ostrovská</p>
										<p className="mb-3 text-muted">
											všeobecný lekár pre dospelých
											<br />
											Bratislava
											<br />
											<b>1&nbsp;694</b>
											pacientov
										</p>
										<div className="h3">
											Vďaka am<b>bee</b> mám údaje svojich pacientov vždy prehľadne poruke.
										</div>
									</div>
								</div>
							</div>
							{/* <!-- Sona Ostrovska --> */}

							<div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
								<div className="card hover-shadow-3d">
									<a>
										<img
											src="public/images/ambee-testimonial-mudr-pavel-stasko-horizontal.jpg"
											alt="MUDr. Pavel Staško, cievny chirurg"
											className="card-img-top"
										/>
									</a>
									<div className="card-body align-items-start">
										<p className="lead mb-0">MUDr. Pavel Staško</p>
										<p className="mb-3 text-muted">
											cievny chirurg
											<br />
											Košice
											<br />
											<b>3&nbsp;147</b> pacientov
										</p>
										<div className="h3">
											am<b>bee</b> mi veľmi uľahčuje administratívu, preto sa môžem naplno venovať liečbe svojich
											pacientov.
										</div>
									</div>
								</div>
							</div>
							{/* <!-- Pavel Stasko --> */}
						</div>
					</div>
				</section>

				<section className="pt-5">
					<div className="container">
						<div className="row">
							<div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay="100">
								<div className="card hover-shadow-3d">
									<a>
										<img
											src="public/images/ambee-testimonial-mudr-adriana-simkova-horizontal.jpg"
											alt="MUDr. Adriana Šimková, všeobecný lekár"
											className="card-img-top"
										/>
									</a>
									<div className="card-body align-items-start">
										<p className="lead mb-0">MUDr. Adriana Šimková, PhD.</p>
										<p className="mb-3 text-muted">
											všeobecný lekár pre dospelých
											<br />
											Pezinok
											<br />
											<b>4&nbsp;068</b>
											pacientov
										</p>
										<div className="h3">
											am<b>bee</b> je môj nový profesionálny kamarát. Odbremenenie od administratívy je na nezaplatenie.
											Program si rýchlo obľúbili i sestričky.
										</div>
									</div>
								</div>
							</div>
							{/* <!-- Adriana Šimková --> */}
						</div>
					</div>
				</section>
			</React.Fragment>
		)
	}
}
